import { executeRequest, Request } from '@jfs/network'
import { bulkRefundsParser } from '../network/parsers/BulkRefundParser'
import { APIEndPoints } from './APIEndpoints'
import { sitConfig } from './config'

const responseParser = (data: any, pageNumber: number) => {
  const respData = bulkRefundsParser(data?.data, pageNumber)
  return respData
}

const getBulkSummary = (
  mid: string,
  fileNameQuery: string,
  createdAt: string,
  updatedAt: string,
  pageNumber: number,
  pageSize: number,
  tokens: any,
  userAccessToken: string,
) => {
  const req = {
    fileName: fileNameQuery && fileNameQuery?.length > 0 ? fileNameQuery : '',
    transactionType: 211,
    initiatingEntityId: 2103,
    entityId: mid,
    fromDate: createdAt,
    toDate: updatedAt,
  }

  const request: Request<{}> = {
    config: sitConfig(tokens),
    apiPath: `${APIEndPoints.BulkRefundList}?page=${pageNumber}&size=${pageSize}`,
    method: 'POST',
    body: req,
    headers: {
      Authorization: userAccessToken,
    },
  }
  return executeRequest(request).then((data) => {
    return responseParser(data, pageNumber)
  })
}

export { getBulkSummary }
